import {
  FormControl,
  InputLabel,
  MenuItem,
  Pagination as MuiPagination,
  Select,
  SelectChangeEvent,
  useTheme,
} from '@mui/material';
import styled from 'styled-components';
import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface Props {
  itemsPerPageDisabled?: boolean;
  paginationDisabled?: boolean;
  count: number;
  page: number;
  itemDescription?: string;
  showItemsPerPage?: string;
  onPageChange: (event: ChangeEvent<unknown>, page: number) => void;
  onItemsPerPageChange?: (event: SelectChangeEvent) => void;
}

const Pagination: FC<Props> = ({
  itemsPerPageDisabled,
  paginationDisabled,
  count,
  page,
  itemDescription,
  showItemsPerPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <PaginationContainer>
      <MuiPagination
        disabled={paginationDisabled}
        count={count}
        page={page}
        onChange={onPageChange}
        variant="outlined"
        shape="rounded"
        sx={{ my: theme.spacing(2) }}
      />
      {itemDescription && showItemsPerPage && onItemsPerPageChange && (
        <FormControl
          disabled={itemsPerPageDisabled}
          size="small"
          sx={{ minWidth: 240 }}
        >
          <InputLabel id={`${itemDescription}-per-page-select-label`}>
            {t('show_items')} {itemDescription}
          </InputLabel>
          <Select
            labelId={`${itemDescription}-per-page-select-label`}
            value={showItemsPerPage}
            label={`${t('show_items')} ${itemDescription}`}
            onChange={onItemsPerPageChange}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      )}
    </PaginationContainer>
  );
};

export default Pagination;
